// extracted by mini-css-extract-plugin
module.exports = {"ch84ijz":"ch84ijz"};